var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-1 mx-0",attrs:{"color":_vm.el.color,"dark":"","small":""}},[_vm._v(_vm._s(_vm.el.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }